module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title32"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429933889_tp01",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429933889_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Elephants, Steamed Duck and Warring States")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Heart of a Tiger or Wolf")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c02",
      "id": "toctitle3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("2")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Grand Scribe’s Records")])]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("and the Place of the Sleeping Tiger")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c03",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Cunning Councillor")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c04",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Cowboys and Indians or Confucianism and Legalism")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c05",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Height of Legal Responsibility")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c06",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("This Species of Fortification: The Great Wall")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c07",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Burning of the Books")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c08",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Making Everything the Same")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c09",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Supreme Forest and the Hall of 10,000 Guests")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c10",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Drugs of Immortality")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c11",
      "id": "toctitle12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("11")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Seas of Mercury, Pearl Stars and an Army of 8,000 Men")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429933889_c12",
      "id": "toctitle13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("12")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The First Emperor and the Great Helmsman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429933889_als01",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Also by")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429933889_bm01",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Notes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429933889_bm02",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chronology")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781429933889_ind01",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429933889_cop01",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6844842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429933889_toc01.vue
// module id = 60
// module chunks = 0